import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';

export default class Map extends Component {

    constructor($element) {
        super($element);

        this.$links = this.$element.find('.map__control a');

        this.$imco = this.$element.find('[data-imco]');

        this.$dots = this.$element.find('[data-imco]');
        this.$cards = this.$element.find('[data-card]');
    }

    prepare() {
        this.$links.on('click', event => {
            event.preventDefault();
            event.stopPropagation();

            this.$links.removeClass('is-active');
            $(event.target).addClass('is-active');

            this.closeCards();
            this.$element.addClass('animation-off');

            if (event.target.hash == '#hq') {
                this.$imco.show();
                this.$element.removeClass('map--distribution');
                this.$element.addClass('map--hq');
            } else if (event.target.hash == '#distribution') {
                this.$imco.hide();
                this.$element.removeClass('map--hq');
                this.$element.addClass('map--distribution');
            } else {
                this.$imco.show();
                this.$element.removeClass('map--distribution');
                this.$element.removeClass('map--hq');
            }
        });

        this.$dots.on('click touchend', event => {
            event.stopPropagation();
            this.handleDotClick(event);
        });

        this.$cards.on('click', event => {
            event.stopPropagation();
        });

        this.$cards.find('.map__close').on('click', event => {
            this.closeCards();
        });

        this.$cards.find('h2').on('click', event => {
            this.openCard($(event.target).parents('.map__card').addClass('is-active'));
        });

        $(document).on('click', event => {
            this.closeCards();
        });

        enquire.register(queries.xLargeUp, {
            match: () => {
                $(window).on('resize', event => {
                    this.closeCards();
                });
            }
        });
    }

    destroy() {
        $(window).off('resize');
    }

    handleDotClick (event) {
        var id = $(event.currentTarget).attr('xlink:href');
        this.closeCards();
        this.openCard(id);

        var $card = this.$element.find(id);
        var $dot = $(event.currentTarget);

        if ($dot.offset().left + 360 >= this.$element.width()) {
            $card.addClass('rtl');
        } else {
            $card.removeClass('rtl');
        }

        $card.css({
            top: $dot[0].getBoundingClientRect().top - this.element.getBoundingClientRect().top + 9,
            left: $dot[0].getBoundingClientRect().left - this.element.getBoundingClientRect().left + 9
        });
    }

    closeCards () {
        this.$cards.removeClass('is-active');
    }

    openCard (id) {
        this.$element.find(id).addClass('is-active');
    }
}



// WEBPACK FOOTER //
// ./components/Map.js